export function pulseCSSClass(elem: HTMLElement, className: string) {
  // "This looks weird, doesn't it? That's because the only way to play an
  // animation again is to remove the animation effect, let the document
  // recompute styles so that it knows you've done that, then add the
  // animation effect back to the element."
  //
  // <https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Animations/Tips#JavaScript_content>
  elem.classList.remove(className);
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      elem.classList.add(className);
    });
  });
}
